module.exports = __webpack_public_path__ + "static/media/ic_dropdown.3bfcdf00.png";